import React, { useState } from "react";

// Global ShowDetails component that works with any title, dates, and amounts
const ShowDetails = ({ dates, amounts, field, data, date }) => {
  const [showPopup, setShowPopup] = useState(false);
  // console.log("dates, amounts, field", data, date, field);

  // Use getDetailsData dynamically based on the field name

  // Split the comma-separated strings into arrays for each row
  const dateList = Array.isArray(date)
    ? date
    : typeof date === "string" && date
    ? date.split(",")
    : [];
  const amountList = Array.isArray(data)
    ? data
    : typeof data === "string" && data
    ? data.split(",")
    : [];

  const showButton = dateList.length > 0 || amountList.length > 0;

  // Toggle popup visibility
  const togglePopup = () => setShowPopup(!showPopup);

  return (
    <div style={{ fontFamily: "Poppins, sans-serif" }}>
      {showButton ? (
        <button
          onClick={togglePopup}
          style={{
            backgroundColor: "#2C3E50",
            color: "white",
            borderRadius: "8px",
            padding: "8px 12px",
            fontWeight: "bold",
            fontFamily: "Poppins, sans-serif",
            boxShadow: "0 6px 10px rgba(0, 0, 0, 0.1)",
            cursor: "pointer",
            marginTop: "10px",
          }}
        >
          Show Details
        </button>
      ) : (
        <span style={{ color: "#C0392B", fontWeight: "bold" }}>
          No data available
        </span>
      )}

      {/* Popup that shows the details */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            padding: "20px",
            backgroundColor: "#FAF8F6", // خلفية ناعمة
            color: "#2C3E50", // لون النص
            boxShadow: "0 10px 20px rgba(0, 0, 0, 0.3)",
            zIndex: 1000,
            borderRadius: "10px",
            maxHeight: "80vh",
            overflowY: "auto",
            width: "300px",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          {dateList.length > 0
            ? dateList.map((date, index) => (
                <div key={index} style={{ paddingBottom: "5px" }}>
                  {new Date(date).toLocaleDateString("en-GB")} -{" "}
                  {amountList[index] || "N/A"}
                </div>
              ))
            : // If no dates exist, render the amountList as an index list
              amountList.map((amount, index) => (
                <div key={index} style={{ paddingBottom: "5px" }}>
                  {` ${index + 1}: ${amount || "N/A"}`}
                </div>
              ))}
          <button
            onClick={togglePopup}
            style={{
              marginTop: "15px",
              backgroundColor: "#C0392B",
              color: "white",
              borderRadius: "6px",
              padding: "6px 10px",
              fontWeight: "bold",
              cursor: "pointer",
              border: "none",
            }}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default ShowDetails;
